module.exports = __webpack_public_path__ + "03a53bf2c5485d821e9c983807871b35.jpg";